import React, { useState ,useEffect, useRef} from 'react';
import * as Yup from "yup";
import { Row, Col, Table } from "react-bootstrap";
import InputField from "../InputField/InputField";
import SlectInputField from "../SlectInputField/SlectInputField";
import TextareaField from "../TextareaField/TextareaField";
import { Formik, Field } from "formik";
import { useParams , useSearchParams,useNavigate } from "react-router-dom";
import { Flip, Slide, toast } from 'react-toastify';
import CustomDateTimePicker from '../InputField/CustomDateTimePicker';
import Axios from '../../lib/axios/axiosInstance';
// import './SendUsMessage.style.css';

const CorporateformCreateSchema = Yup.object().shape({
  type: Yup.string().required("Type is required"),
  subject: Yup.string().required("Subject is required"),
  body: Yup.string().required("Message is required"),
});

const CorporateformUpdateSchema = Yup.object().shape({
  status: Yup.string().required("Status is required"),
  reply: Yup.string().required("Reply is required")
});

const Request = ({showDetailsId,callBack}) => {
  const navigate = useNavigate();  
    const [details, setDetails] = useState(false)
    const [reqDate,setReqDate] = useState(new Date())
    const [initialValue, setInitialValue] = useState({
        status: "",
        reply: "",
    });

  const createFormSubmitHandler = async(values,resetForm)=>{

      var val = {
        "request": {
            type: values.type,
            subject: values.subject,
            message: values.body,
        }
    }
    // Submit New Request
    // api/account/request
    await Axios.post('/account/request/',val)
    .then(async (response) =>{
      if (response && response.status == 200 && response.data.data?.request?.refnum) {
        toast.success('Request sended successfully !', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
          transition: Slide,
        });
        resetForm();
        callBack();
      }
      else {
        toast.error('Something went Wrong!', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
          transition: Flip,
        })
      }
    });
  } 
  const updateFormSubmitHandler = async (values,resetForm) => {
    
      var val = {
        "reply": {
            refnum: details.refnum,
            reply: values.reply,
            status: values.status,
        }
    }
    debugger
    // Submit New Request
    // api/account/request
    await Axios.post('/account/request/reply',val)
    .then(async (response) =>{
      if (response && response.status == 200 && response.data.data?.carth?.refnum) {
        toast.success('Reply sended successfully !', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
          transition: Slide,
        });
        resetForm();
        navigate('/my-account?activeKey=Request')
      }
      else {
        toast.error('Something went Wrong!', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
          transition: Flip,
        })
      }
    });
    
  };

  useEffect(async () => {
    if(showDetailsId){
        // View Request
        // api/account/request/:refnum
        await Axios.get(`/account/request/${showDetailsId}`)
        .then(async (response) =>{
        if (response && response.status == 200 && response.data.data?.request) {
            setInitialValue({
                type: response.data.data?.request.type,
                subject: response.data.data?.request.subject,
                body: response.data.data?.request.message,
                status: response.data.data?.request.status,
                reply: response.data.data?.request.reply
            })
            setDetails(response.data.data?.request)
        }
        else {
            toast.error('Something went Wrong!', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Flip,
            })
        }
        });
    }
  }, [showDetailsId]);

  return (
    <>
    <div>
    <br />
    <div id="accordion">
    <div className="page-content checkout-page">
            <div className="box-border">
            {showDetailsId ?
              <Formik
                initialValues={initialValue}
                validationSchema={CorporateformUpdateSchema}
                onSubmit={(values, { setSubmitting,resetForm  }) => {
                  // console.log(values);
                  updateFormSubmitHandler(values,resetForm);
                  setSubmitting(false);
                }}
                enableReinitialize
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Col xl={12} sm={12} xs={12}>
                        <Row>
                            {showDetailsId && <>
                            <Col xl={12} sm={12} md={12}>
                                <Row>
                                    <Col xl={4} sm={4} md={4}>Ticket #</Col>
                                    <Col xl={8} sm={8} md={8}>
                                    <input
                                        Type="text"
                                        readOnly={true}
                                        value={details.refnum}
                                        className='form-control'
                                    />
                                    </Col>
                                </Row>   
                            </Col>
                            </>}
                            <Col xl={12} sm={12} md={12}>
                              <Row>
                                <Col xl={4} sm={4} md={4}>Type</Col>
                                <Col xl={8} sm={8} md={8}>
                                    <input
                                        Type="text"
                                        readOnly={true}
                                        value={details.type}
                                        className='form-control'
                                    />
                                </Col>
                              </Row>   
                            </Col>
                            <br/>
                            <br/>
                            <Col xl={12} sm={12} md={12}>
                              <Row>
                                <Col xl={4} sm={4} md={4}>Subject</Col>
                                <Col xl={8} sm={8} md={8}>
                                    <input
                                        Type="text"
                                        readOnly={true}
                                        value={details.subject}
                                        className='form-control'
                                    />  
                                </Col>
                              </Row>   
                            </Col>

                            <Col xl={12} sm={12} md={12}>
                              <Row>
                                <Col xl={4} sm={4} md={4}>Message</Col>
                                <Col xl={8} sm={8} md={8}>
                                    <textarea
                                        rows={15}
                                        Type="text"
                                        readOnly={true}
                                        value={details.message}
                                        className='form-control'
                                    />
                                </Col>
                              </Row>   
                            </Col>
                            <br/>
                            <Col xl={12} sm={12} md={12}>
                              <Row>
                                <Col xl={4} sm={4} md={4}>Date</Col>
                                <Col xl={8} sm={8} md={8}>
                                <CustomDateTimePicker 
                                  startYear={1970}
                                  value={new Date(reqDate)}
                                  onChange={(e)=>{handleChange({type:"change",target:{value:e}}); setReqDate(e)}}
                                  className={(errors.date && touched.date ) ? 'is-invalid' : 'form-control'}
                                />
                                </Col>
                              </Row>   
                            </Col>
                            <Col xl={12} sm={12} md={12}>
                              <Row>
                                <Col xl={4} sm={4} md={4}>Status</Col>
                                <Col xl={8} sm={8} md={8}>
                                  <SlectInputField
                                    Name="status"
                                    placeHolder="Select Status"
                                    options={[
                                      { label: "Open", value:  "Open"},
                                      { label: "Processing", value:  "Processing"},
                                      { label: "Closed", value:  "Closed"}
                                    ]}
                                    value={values.status}
                                    onChange={e=>{handleChange(e); }}
                                    onBlur={handleBlur}
                                    className={
                                      (errors.status && touched.status
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                </Col>
                              </Row>   
                            </Col>
                            <Col xl={12} sm={12} md={12}>
                              <Row>
                                <Col xl={4} sm={4} md={4}>Reply</Col>
                                <Col xl={8} sm={8} md={8}>
                                  <TextareaField
                                    Rows={15}
                                    Name="reply"
                                    id="reply"
                                    Type="text"
                                    value={values.reply}
                                    onChange={handleChange}
                                    isInvalid={!!errors.reply}
                                    className={(errors.reply && touched.reply) ? 'is-invalid customTextArea' : 'form-control customTextArea'}
                                  />
                                </Col>
                              </Row>   
                            </Col>
                          </Row>
                        </Col>

                    <Col xl={12} sm={12} xs={12}>
                      <Row>
                        
                        <Col xl={12} sm={12}>
                          <button className="button" type="button" onClick={() => navigate('/my-account?activeKey=Request')}><span>Back to Request Listing</span></button>
                          <button type="submit" className="button" style={{float:"right"}}>
                            Send Reply
                          </button>
                        </Col>
                      </Row>
                    </Col>
                  </form>
                )}
              </Formik>
              :
              <Formik
                initialValues={initialValue}
                validationSchema={CorporateformCreateSchema}
                onSubmit={(values, { setSubmitting,resetForm  }) => {
                  // console.log(values);
                  createFormSubmitHandler(values,resetForm);
                  setSubmitting(false);
                }}
                enableReinitialize
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Col xl={12} sm={12} xs={12}>
                        <Row>
                            <Col xl={12} sm={12} md={12}>
                              <Row>
                                <Col xl={4} sm={4} md={4}>Type</Col>
                                <Col xl={8} sm={8} md={8}>
                                  <SlectInputField
                                    Name="type"
                                    placeHolder="Select Type"
                                    options={[
                                      { label: "Enquiries", value:  "Enquiries"},
                                      { label: "Feedback", value:  "Feedback"},
                                      { label: "Compliment", value:  "Compliment"}
                                    ]}
                                    value={values.type}
                                    onChange={e=>{handleChange(e); }}
                                    onBlur={handleBlur}
                                    className={
                                      (errors.type && touched.type
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                </Col>
                              </Row>   
                            </Col>
                            <br/>
                            <br/>
                            <Col xl={12} sm={12} md={12}>
                              <Row>
                                <Col xl={4} sm={4} md={4}>Subject</Col>
                                <Col xl={8} sm={8} md={8}>
                                  <InputField
                                    Name="subject"
                                    id="subject"
                                    Type="text"
                                    value={values.subject}
                                    onChange={handleChange}
                                    isInvalid={!!errors.subject}
                                    className={(errors.subject && touched.subject) ? 'is-invalid' : 'form-control'}
                                  />
                                </Col>
                              </Row>   
                            </Col>

                            <Col xl={12} sm={12} md={12}>
                              <Row>
                                <Col xl={4} sm={4} md={4}>Message</Col>
                                <Col xl={8} sm={8} md={8}>
                                  <TextareaField
                                    Rows={15}
                                    Name="body"
                                    id="body"
                                    Type="text"
                                    value={values.body}
                                    onChange={handleChange}
                                    isInvalid={!!errors.body}
                                    className={(errors.body && touched.body) ? 'is-invalid customTextArea' : 'form-control customTextArea'}
                                  />
                                </Col>
                              </Row>   
                            </Col>
                          </Row>
                        </Col>

                    <Col xl={12} sm={12} xs={12}>
                      <Row>
                        <Col xl={12} sm={12}>
                          <button type="submit" className="button" style={{float:"right"}}>
                            Send Request
                          </button>
                        </Col>
                      </Row>
                    </Col>
                  </form>
                )}
              </Formik>
            }
            </div>
          </div>
      </div>
  </div>
    <br />
    <br />
    </>
  );
};

export default Request;
